<template>
  <div>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          Pamiętaj, że jesteśmy dla Ciebie!
        </div>
        <div class="textWhyPhone">
          Masz problem, o którym wstydzisz się mówić? Potrzebujesz wsparcia, ale
          nie wiesz, co Ci dolega? Oczekujesz rzetelnego podejścia i
          profesjonalnego planu leczenia? Skontaktuj się z nami i pozwól sobie
          pomóc!
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          Pamiętaj, że jesteśmy dla Ciebie!
        </div>
        <div class="textWhy">
          Masz problem, o którym wstydzisz się mówić? Potrzebujesz wsparcia, ale
          nie wiesz, co Ci dolega? Oczekujesz rzetelnego podejścia i
          profesjonalnego planu leczenia? Skontaktuj się z nami i pozwól sobie
          pomóc!
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application .grey--text {
  color: #414149 !important;
}

.infText {
  margin: auto;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  text-align: justify;
  text-align-last: left;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.textCenter {
  text-align-last: left;
}

h1 {
  margin: auto;
}
</style>
